/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const ModalCertificateHolders = ({
  show,
  handleClose,
  isMobile,
  validVenueAddress,
  certHolders,
  hasVenueCodeReferral,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => handleClose()}
      dialogClassName="modal--certificateHolders"
    >
      <Modal.Header
        className={`w-100 border-0 p-0 mb-5 ${
          isMobile ? 'd-flex flex-column-reverse' : ''
        }`}
        closeButton
      >
        <h4 className="font-weight-bold m-0">
          Preview Additional Certificate Holders
        </h4>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="container p-0">
          <p className="mb-3">
            Review the information displayed below. If you need to add someone
            else, please contact customer service.
          </p>
          <div className="row p-1">
            {certHolders.map((address, i) => (
              <div key={i} className="col-sm-12 col-md-6 modal--certHolders">
                {address.split('\n').map((line, j) => (
                  <div key={j} className={j === 0 ? 'font-weight-bold' : ''}>
                    {line}
                  </div>
                ))}
              </div>
            ))}
            {!validVenueAddress && !hasVenueCodeReferral && (
              <div
                className={`col-sm-12 col-md${
                  certHolders.length ? '-6' : ''
                } modal--certHolders`}
              >
                <em>
                  {!certHolders.length
                    ? `Additional insured information may show here once a
                        venue is selected`
                    : `Venue information will show here when selected`}
                </em>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ModalCertificateHolders.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  validVenueAddress: PropTypes.bool.isRequired,
  certHolders: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasVenueCodeReferral: PropTypes.bool.isRequired,
};

export default ModalCertificateHolders;
